import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Add a new row ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Select file")
const _hoisted_3 = {
  slot: "footer",
  class: "dialog-footer"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_6 = {
  slot: "footer",
  class: "dialog-footer"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "el-icon-time" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Remove ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_AsyncImage = _resolveComponent("AsyncImage")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode(_component_el_button, {
        icon: "el-icon-plus",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = true))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogVisible = $event)),
        title: "Add a new row",
        width: "30%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Name" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.newRecord.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newRecord.name = $event)),
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "Notes" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.newRecord.note,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newRecord.note = $event)),
                    required: "",
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "File" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    ref: "uploadRef",
                    "file-list": _ctx.fileList,
                    "onUpdate:file-list": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fileList = $event)),
                    "auto-upload": false,
                    action: "",
                    limit: 1
                  }, {
                    default: _withCtx(() => []),
                    trigger: _withCtx(() => [
                      _withDirectives(_createVNode("div", null, [
                        _createVNode(_component_el_button, { type: "primary" }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ], 512), [
                        [_vShow, _ctx.fileSelected()]
                      ])
                    ]),
                    _: 1
                  }, 8, ["file-list"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogVisible = false))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.addNewRecord
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.changeDialog,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeDialog = $event)),
        title: "Edit note",
        width: "30%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Notes" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.changeRecord.note,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeRecord.note = $event)),
                    required: "",
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_el_button, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeDialog = false))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.changeNote
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _withDirectives(_createVNode(_component_el_container, {
      class: "additional_information_report",
      direction: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.records,
          stripe: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "Name"
            }, {
              default: _withCtx(({row}) => [
                _createVNode("span", null, _toDisplayString(row.data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "note",
              label: "Notes"
            }, {
              default: _withCtx(({row}) => [
                _createVNode("span", null, _toDisplayString(row.data.note), 1),
                _hoisted_9,
                _createVNode("a", {
                  onClick: _ => _ctx.showDialogFor(row._id, row.data),
                  class: "changeLink"
                }, " Edit ", 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "value",
              label: "File"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_AsyncImage, {
                  data: row.data.file,
                  report_id: _ctx.report._id
                }, null, 8, ["data", "report_id"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "timestamp",
              label: "Timestamp"
            }, {
              default: _withCtx(({row}) => [
                _createVNode("p", null, [
                  _hoisted_10,
                  _createTextVNode(" " + _toDisplayString(_ctx.convertDateString(row.timestamp, _ctx.userPrefs?.timezone)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              label: "Operations",
              width: "120"
            }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "mini",
                  onClick: () => _ctx.deleteRecord(row._id)
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 512), [
      [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
    ])
  ], 64))
}